import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a0766108&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0766108')) {
      api.createRecord('a0766108', component.options)
    } else {
      api.reload('a0766108', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=a0766108&", function () {
      api.rerender('a0766108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Users/Index.vue"
export default component.exports